/**
 * Раскладка подписей клавиш. `auto` — определяется по среде, `apple` и `other` форсируют
 * результат: нужны в тестах, на стенде и в справке, где обе раскладки показывают рядом.
 */
export type KbdPlatform = 'auto' | 'apple' | 'other'

import { isApplePlatform } from '@/shared/lib'

/** Разрешает проп в конкретную раскладку: `auto` спрашивает среду, остальное берётся как есть. */
export function resolvePlatform(platform: KbdPlatform): 'apple' | 'other' {
  if (platform === 'auto') return isApplePlatform() ? 'apple' : 'other'
  return platform
}
